export const BV_CONFIG: BazaarvoiceJsonData[] = [
  {
    "id": "ic",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067-en_gb"
      },
      {
        "key": "es-US",
        "value": "2067-es_es"
      },
      {
        "key": "zh-CN",
        "value": "2067-zh_cn"
      },
      {
        "key": "de-DE",
        "value": "2067-de_de"
      },
      {
        "key": "fr-FR",
        "value": "2067-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067-pt_br"
      }
    ]
  },
  {
    "id": "cw",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067cw-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067cw-en_us"
      },
      {
        "key": "es-US",
        "value": "2067cw-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067cw-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067cw-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067cw-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067cw-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067cw-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067cw-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067cw-pt_br"
      }
    ]
  },
  {
    "id": "cp",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067cp-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067cp-en_us"
      },
      {
        "key": "es-US",
        "value": "2067cp-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067cp-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067cp-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067cp-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067cp-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067cp-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067cp-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067cp-pt_br"
      }
    ]
  },
  {
    "id": "hi",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067hi-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067hi-en_us"
      },
      {
        "key": "es-US",
        "value": "2067hi-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067hi-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067hi-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067hi-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067hi-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067hi-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067hi-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067hi-pt_br"
      }
    ]
  },
  {
    "id": "va",
    "entry":[
      {
        "key": "en-US",
        "value": "2067va-en_us"
      }
    ]
  },
  {
    "id": "ex",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067ex-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067ex-en_us"
      },
      {
        "key": "es-US",
        "value": "2067ex-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067ex-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067ex-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067ex-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067ex-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067ex-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067ex-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067ex-pt_br"
      }
    ]
  },
  {
    "id": "hc",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067hc-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067hc-en_us"
      },
      {
        "key": "es-US",
        "value": "2067hc-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067hc-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067hc-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067hc-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067hc-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067hc-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067hc-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067hc-pt_br"
      }
    ]
  },
  {
    "id": "in",
    "entry": [
      {
        "key": "en-US",
        "value": "2067in-en_us"
      },
      {
        "key": "es-US",
        "value": "2067in-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067in-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067in-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067in-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067in-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067in-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067in-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067in-pt_br"
      }
    ]
  },
  {
    "id": "vn",
    "entry": [
      {
        "key": "en-US",
        "value": "2067vn-en_us"
      },
      {
        "key": "es-US",
        "value": "2067vn-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067vn-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067vn-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067vn-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067vn-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067vn-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067vn-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067vn-pt_br"
      }
    ]
  },
  {
    "id": "sb",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067sb-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067sb-en_us"
      },
      {
        "key": "es-US",
        "value": "2067sb-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067sb-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067sb-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067sb-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067sb-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067sb-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067sb-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067sb-pt_br"
      }
    ]
  },
  {
    "id": "pcr",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067pc-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067pc-en_us"
      },
      {
        "key": "es-US",
        "value": "2067pc-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067pc-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067pc-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067pc-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067pc-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067pc-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067pc-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067pc-pt_br"
      }
    ]
  },
  {
    "id": "6c",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067ic-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067ic-en_us"
      },
      {
        "key": "es-US",
        "value": "2067ic-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067ic-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067ic-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067ic-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067ic-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067ic-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067ic-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067ic-pt_br"
      }
    ]
  },
  {
    "id": "ul",
    "entry": [
      {
        "key": "en-GB",
        "value": "2067ul-en_gb"
      },
      {
        "key": "en-US",
        "value": "2067ul-en_us"
      },
      {
        "key": "es-US",
        "value": "2067ul-es_es"
      },
      {
        "key": "de-DE",
        "value": "2067ul-de_de"
      },
      {
        "key": "zh-CN",
        "value": "2067ul-zh_cn"
      },
      {
        "key": "fr-FR",
        "value": "2067ul-fr_fr"
      },
      {
        "key": "ja-JP",
        "value": "2067ul-ja_jp"
      },
      {
        "key": "it-IT",
        "value": "2067ul-it_it"
      },
      {
        "key": "ru-RU",
        "value": "2067ul-ru_ru"
      },
      {
        "key": "pt-PT",
        "value": "2067ul-pt_br"
      }
    ]
  }
];

interface BazaarvoiceJsonData {
  id: string;
  entry: (EntryEntity)[] | null;
}
interface EntryEntity {
  key: string;
  value: string;
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/baazarvoice/displayCode.config.ts